// extracted by mini-css-extract-plugin
export default {"socialLink":"SocialLink_socialLink__5OU+3"};